import CustomButton from "components/common/CustomButton";

interface IInfoAreaFile {
    title: string,
    file: File[];
}

const InfoAreaFile = ({ title, file }: IInfoAreaFile) => {
    const download = (file: File) => {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        a.target = '_blank';
        a.click();
        URL.revokeObjectURL(url); // 💡 메모리 해제
    };

    return (
        <div className="flex flex-col gap-6">
            {
                file &&
                file.map((item, idx) => (
                    <div className='flex items-start' key={idx}>
                        <p className='w-[170px] text-lg shrink-0'>{idx === 0 && title}</p>

                        <div className='flex flex-1 bg-[#F8F8FA] rounded min-h-10'>
                            <div className="flex flex-1 items-center px-6 text-left">
                                {item.name}
                            </div>
                            <CustomButton
                                className="bg-primary min-w-[70px] !h-10 !text-sm"
                                title="다운로드"
                                onClick={() => download(item)}
                            />
                        </div>
                    </div>
                ))
            }
        </div >
    )
}

export default InfoAreaFile